module.exports = __webpack_public_path__ + "img/capacity_en.d7369313.svg";